import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Select from 'components/forms/Select';
import { resultsToOptions } from 'utils/misc';
import { getOpportunities } from 'redux/actions/opportunityActions';


const OpportunityFilter = ({
  value, onChange, options, ...props
}) => {
  const handleLoadOptions = async (filterString) => {
    const data = await props.getOpportunities({ search: filterString });
    const results = resultsToOptions(data.results, 'title') || [];
    results.unshift({ label: 'All', value: 'all' }, { label: 'Unknown', value: 'unknown' });
    return results;
  };

  return (
    <Select
      isMulti
      placeholder="Opportunity"
      value={value}
      onChange={onChange}
      cacheOptions
      defaultOptions={options}
      loadOptions={handleLoadOptions}
    />
  );
};

OpportunityFilter.propTypes = {
  value: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  opportunities: PropTypes.shape({
    results: PropTypes.shape({}.isRequired),
  }).isRequired,
  getOpportunities: PropTypes.func.isRequired,
};

export default compose(connect(
  state => ({
    opportunities: state.opportunities,
    user: state.user,
  }),
  { getOpportunities },
))(OpportunityFilter);
